import Vue from 'vue'
import Router from 'vue-router'
import chat from '@/views/chat/index.vue'
import consultation from '../../packages/appletView/src/pages/consultations/consultations.vue'
import consultationDetail from '../../packages/appletView/src/pages/consultations/consultations-detail.vue'
import inHospital from '../../packages/appletView/src/pages/inHospital/inHospital.vue'
import inHospitalDetail from '../../packages/appletView/src/pages/inHospital/inHospital-detail.vue'
import report from '../../packages/appletView/src/pages/report/report.vue'
import reportDetail from '../../packages/appletView/src/pages/report/report-detail.vue'
import image from '../../packages/appletView/src/pages/image/image.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL, // 如果使用history模式，必须设置base参数
  routes: [
    {
      path: '/',
      name: 'chart',
      component: chat
    },
    {
      path: '/consultation',
      name: 'consultation',
      component: consultation
    },
    {
      path: '/consultationDetail',
      name: 'consultationDetail',
      component: consultationDetail
    },
    {
      path: '/inHospital',
      name: 'inHospital',
      component: inHospital
    },
    {
      path: '/inHospitalDetail',
      name: 'inHospitalDetail',
      component: inHospitalDetail
    },
    {
      path: '/report',
      name: 'report',
      component: report
    },
    {
      path: '/reportDetail',
      name: 'reportDetail',
      component: reportDetail
    },
    {
      path: '/image',
      name: 'image',
      component: image
    }
  ]
})



// WEBPACK FOOTER //
// ./examples/router/index.js